export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./BigSlider.vue?vue&type=template&id=66bd2767&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/BigSlider.vue?vue&type=template&id=66bd2767&scoped=true&
// module id = 264
// module chunks = 0